export default "__VITE_ASSET__v6WekQbg__"